"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createReducer2 = _interopRequireDefault(require("../createReducer"));

var _displayPreferencesActionKeys = _interopRequireDefault(require("./displayPreferencesActionKeys"));

var _createReducer;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var storageKey = 'displayPreferences';

function logLocalStorageWarning() {
  // eslint-disable-next-line no-console
  console.warn('localStorage is undefined. Avoid using displayPreferencesReducer on the server.');
}

function getDisplayPreferences() {
  if (typeof localStorage === 'undefined') {
    logLocalStorageWarning();
    return {};
  }

  var storageValue = localStorage.getItem(storageKey);
  return storageValue ? JSON.parse(storageValue) : {};
}

function removeDisplayPreference(key) {
  if (typeof localStorage === 'undefined') {
    logLocalStorageWarning();
    return {};
  }

  var storageValue = getDisplayPreferences();
  delete storageValue[key];

  var nextStorageValue = _objectSpread({}, storageValue);

  localStorage.setItem(storageKey, JSON.stringify(nextStorageValue));
  return nextStorageValue;
}

function setDisplayPreference(key, value) {
  if (typeof localStorage === 'undefined') {
    logLocalStorageWarning();
    return {};
  }

  var storageValue = getDisplayPreferences();

  var nextStorageValue = _objectSpread(_objectSpread({}, storageValue), {}, (0, _defineProperty2.default)({}, key, value));

  localStorage.setItem(storageKey, JSON.stringify(nextStorageValue));
  return nextStorageValue;
}

var displayPreferencesReducer = (0, _createReducer2.default)({}, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, _displayPreferencesActionKeys.default.GET_DISPLAY_PREFERENCES, function (state, action) {
  return _objectSpread({}, getDisplayPreferences());
}), (0, _defineProperty2.default)(_createReducer, _displayPreferencesActionKeys.default.REMOVE_DISPLAY_PREFERENCE, function (state, action) {
  var key = action.payload.key;
  var nextStorageValue = removeDisplayPreference(key);
  return nextStorageValue;
}), (0, _defineProperty2.default)(_createReducer, _displayPreferencesActionKeys.default.SET_DISPLAY_PREFERENCE, function (state, action) {
  var _action$payload = action.payload,
      key = _action$payload.key,
      value = _action$payload.value;
  var nextStorageValue = setDisplayPreference(key, value);
  return nextStorageValue;
}), _createReducer), false);
var _default = displayPreferencesReducer;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/displayPreferences/displayPreferencesReducer.js
// module id = 4438
// module chunks = 25